import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/_ui/nav/site-nav.tsx");
